import { createFileRoute } from '@tanstack/react-router';
import { ProtectedComponent } from '@components/ProtectedComponent';
import { FallbackType, UserRole } from '@shared-types/auth.types';
import { PageHeader } from '@components/ui/PageHeader';
import { Stack } from '@mantine/core';
import { adminMetricsQueryOptions } from '@api/admin/adminQueries';
import { AdminPendingComponent } from '@features/admin/components/AdminPendingComponent';
import { AdminErrorComponent } from '@features/admin/components/AdminErrorComponent';
import { ControlCenterPage } from '@features/admin/components/ControlCenterPage';

export const Route = createFileRoute('/_authed/admin/')({
  loader: ({context: {queryClient}}) =>
    queryClient.ensureQueryData(adminMetricsQueryOptions()),
  pendingComponent: AdminPendingComponent,
  errorComponent: AdminErrorComponent,
  component: ControlCenterRoute,
});

function ControlCenterRoute() {
  return (
    <ProtectedComponent
      requiredRole={UserRole.Admin}
      fallbackType={FallbackType.Page}
      fallbackTitle="Control Center"
      fallbackAction="access the admin control center"
    >
      <Stack gap="lg">
        <PageHeader
          title="Control Center"
          subtitle="Fleet Management Administration"
          backButton={false}
        />
        <ControlCenterPage/>
      </Stack>
    </ProtectedComponent>
  );
}
